import { render, staticRenderFns } from "./VolunteerList.vue?vue&type=template&id=0bfde75c&scoped=true"
import script from "./VolunteerList.vue?vue&type=script&lang=js"
export * from "./VolunteerList.vue?vue&type=script&lang=js"
import style0 from "./VolunteerList.vue?vue&type=style&index=0&id=0bfde75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfde75c",
  null
  
)

export default component.exports